/* tslint:disable */
/* eslint-disable */
/**
 * Sports App Training Plans
 * API for the Sports App Training Plans
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateDeckDTO
 */
export interface CreateDeckDTO {
    /**
     * 
     * @type {string}
     * @memberof CreateDeckDTO
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDeckDTO
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDeckDTO
     */
    imageId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDeckDTO
     */
    ownerId?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateDeckDTO
     */
    deckImageNumber?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateDeckDTO
     */
    editorIds?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateDeckDTO
     */
    cardBackImageIds?: Array<string>;
}

/**
 * Check if a given object implements the CreateDeckDTO interface.
 */
export function instanceOfCreateDeckDTO(value: object): value is CreateDeckDTO {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function CreateDeckDTOFromJSON(json: any): CreateDeckDTO {
    return CreateDeckDTOFromJSONTyped(json, false);
}

export function CreateDeckDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateDeckDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'imageId': json['imageId'] == null ? undefined : json['imageId'],
        'ownerId': json['ownerId'] == null ? undefined : json['ownerId'],
        'deckImageNumber': json['deckImageNumber'] == null ? undefined : json['deckImageNumber'],
        'editorIds': json['editorIds'] == null ? undefined : json['editorIds'],
        'cardBackImageIds': json['cardBackImageIds'] == null ? undefined : json['cardBackImageIds'],
    };
}

export function CreateDeckDTOToJSON(json: any): CreateDeckDTO {
    return CreateDeckDTOToJSONTyped(json, false);
}

export function CreateDeckDTOToJSONTyped(value?: CreateDeckDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'imageId': value['imageId'],
        'ownerId': value['ownerId'],
        'deckImageNumber': value['deckImageNumber'],
        'editorIds': value['editorIds'],
        'cardBackImageIds': value['cardBackImageIds'],
    };
}

